import React from "react"

import {CustomIconProps} from "./type/CustomIconProps"

export const SendIcon = ({stroke = "#307ADE", size = 16, fill = "none", ...props}: CustomIconProps) => {
    return (
        <svg
            width={size}
            height={size * (14 / 16)}
            viewBox="0 0 16 14"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.37159 6.33087L6.76407 12.5966C6.93784 13.3774 7.97493 13.5457 8.38614 12.86L14.8721 2.04964C15.2267 1.45994 14.8021 0.709839 14.1141 0.709839H1.88685C1.09822 0.709839 0.703514 1.6628 1.26098 2.22026L5.37159 6.33087Z"
                stroke={stroke}
                fill={fill}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8746 1.15015L5.36859 6.33166"
                stroke={stroke}
                fill={fill}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
